import { apiFetch } from "./client";

export const checkAuth = () =>
  apiFetch("/enduser/check-auth/");

export const login = ({ email, password, remember_me }) =>
  apiFetch("/enduser/login/", {
    method: "POST",
    body: { email, password, remember_me },
  });

export const phoneAuth = (id_token) =>
  apiFetch("/enduser/phone-auth/", {
    method: "POST",
    body: { id_token },
  });

export const logout = () =>
  apiFetch("/enduser/logout/", {
    method: "POST",
  });

export const register = (payload) =>
  apiFetch("/enduser/register/", {
    method: "POST",
    body: payload,
  });

export const sendResetCodeApi = (email) =>
  apiFetch("/enduser/reset/send/", {
    method: "POST",
    body: { email },
  });

export const verifyResetCodeApi = (email, code) =>
  apiFetch("/enduser/reset/verify/", {
    method: "POST",
    body: { email, code },
  });

export const resetPasswordApi = (email, code, password) =>
  apiFetch("/enduser/reset/password/", {
    method: "POST",
    body: { email, code, password },
  });
